import ConfiguracionRepository from '@/services/ConfiguracionRepository'

export default {
  namespaced: true,
  state: {
    establecimiento: {nombreEstablecimiento: 'Elija Establecimiento', idEstablecimiento: null, hasAgro: false, hasGanaderia:false},
    establecimientosList: [],
    grupoExplotacionList: [],
    currentGrupoExplotacion: {categoria: 0, idGrupoExplotacion: 0, nombre: '', tipo: 0},
    updateEstablecimientoLists: false,
    lastEstablecimiento: 0
  },
  getters: {
    isEstablecimientoSet(state){
      return state.establecimiento.idEstablecimiento !== null
    },
    hasCategoriaAgricultura(state){
      return state.establecimiento.hasAgro
    },
    hasCategoriaGanaderia(state){
      return state.establecimiento.hasGanaderia
    },
    ganaderiaExplotacion(state){
      let index = state.grupoExplotacionList.map(explotacion => explotacion.categoria).indexOf(2)
      return index >= 0 ? state.grupoExplotacionList[index] : null
    },
    currentCategoria(state){
      return state.currentGrupoExplotacion?.categoria || 0
    },
    filteredEstablecimientoList(state){
      return state.establecimientosList.filter(establecimiento => establecimiento.idEstablecimiento !== state.establecimiento.idEstablecimiento)
    },
    nextEstablecimiento(state){
      let length = state.establecimientosList.length
      let current = 0
      let next = 0
      if(length !== 0){
        current = state.establecimientosList.map(establecimiento => establecimiento.idEstablecimiento).indexOf(state.establecimiento.idEstablecimiento)
        next = current + 1
      }
      return next < length ? state.establecimientosList[next] : state.establecimientosList[0]
    },
    previousEstablecimiento(state){
      let length = state.establecimientosList.length
      let current = 0
      let previous = 0
      if(length !== 0){
        current = state.establecimientosList.map(establecimiento => establecimiento.idEstablecimiento).indexOf(state.establecimiento.idEstablecimiento)
        previous = current - 1
      }
      return previous >= 0 ? state.establecimientosList[previous] : state.establecimientosList[length-1]
    },
  },
  mutations: {
    setEstablecimiento(state, establecimiento){
      if(establecimiento){
        establecimiento.hasAgro = false
        establecimiento.hasGanaderia = false
        establecimiento?.grupoExplotacionList.map(grupo => {
          grupo.categoria === 1 ? establecimiento.hasAgro = true : establecimiento.hasGanaderia = true
        })
        state.establecimiento = establecimiento
        localStorage.setItem('selectedEstablecimiento',JSON.stringify(state.establecimiento))
        state.lastEstablecimiento = state.establecimiento.idEstablecimiento
        localStorage.setItem('lastEstablecimiento',JSON.stringify(state.lastEstablecimiento))
        
      }
    },
    setGrupoExplotacion(state,grupoExplotacion){
      state.currentGrupoExplotacion = grupoExplotacion
      localStorage.setItem('selectedGrupoExplotacion',JSON.stringify(state.currentGrupoExplotacion))
    },

    setGrupoExplotacionList(state,grupoExplotacionList){
      state.grupoExplotacionList = grupoExplotacionList
      localStorage.setItem('grupoExplotacionList',JSON.stringify(state.grupoExplotacionList))
    },

    restoreGrupoExplotacionList(state){
      let grupoExplotacionList = localStorage.getItem('grupoExplotacionList')
      if (grupoExplotacionList && grupoExplotacionList != 'undefined') {
        state.grupoExplotacionList = JSON.parse(grupoExplotacionList)
      }
    },

    restoreEstablecimiento(state) {
      let selectedEstablecimiento = localStorage.getItem('selectedEstablecimiento')

      if (selectedEstablecimiento) {
        state.establecimiento = JSON.parse(selectedEstablecimiento)
      }
      
      let lastEstablecimiento = localStorage.getItem('lastEstablecimiento')

      if (lastEstablecimiento) {
        state.lastEstablecimiento = JSON.parse(lastEstablecimiento)
      }
    },

    setEstablecimientoList(state, establecimientosList){
      if(establecimientosList && establecimientosList.length !== 0 ){
        state.establecimientosList = establecimientosList
      }
    },

    clearEstablecimiento(state){
      if(state.establecimiento.idEstablecimiento === state.lastEstablecimiento){
        state.lastEstablecimiento = 0
        localStorage.removeItem('lastEstablecimiento')
      }
      state.establecimiento = {nombreEstablecimiento: 'Elija Establecimiento', idEstablecimiento: null, hasAgro: false, hasGanaderia:false}
      state.grupoExplotacionList = []
      state.currentGrupoExplotacion = {categoria: 0, idGrupoExplotacion: 0, nombre: '', tipo: 0}
      localStorage.removeItem('selectedEstablecimiento')
      localStorage.removeItem('selectedGrupoExplotacion')
      localStorage.removeItem('grupoExplotacionList')
    },

    clearEstablecimientoList(state){
      state.establecimientosList = []
    },
  },
  actions: {
    async setEstablecimiento({state,commit,dispatch}, establecimiento){
      commit('setEstablecimiento', establecimiento)

      let selectedGrupoExplotacion = localStorage.getItem('selectedGrupoExplotacion')
      if (selectedGrupoExplotacion && selectedGrupoExplotacion != 'undefined') {
        let currentGrupoExplotacion = JSON.parse(selectedGrupoExplotacion)
        commit('setGrupoExplotacion',currentGrupoExplotacion)
        if(establecimiento.grupoExplotacionList && establecimiento.grupoExplotacionList.length !== 0){
          commit('setGrupoExplotacionList', establecimiento.grupoExplotacionList)
        }
      }else if(establecimiento.grupoExplotacionList && establecimiento.grupoExplotacionList.length !== 0){
        commit('setGrupoExplotacion',establecimiento.grupoExplotacionList[0])
        commit('setGrupoExplotacionList', establecimiento.grupoExplotacionList)
      }
      
      await dispatch('session/clear', null, {root: true})
      await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
      await dispatch('temporada/fetchListaTemporadaAgricultor', null, {root:true})
      await dispatch('temporada/fetchTemporadaActual', null, {root:true})
      await dispatch('fichas/fetchListaFichaAgricola', null, {root: true})
      await dispatch('personal/fetchListaPersonalAgricultor', null, {root:true})
      await dispatch('maquinas/fetchListaInventario', null, {root:true})
      if(state.establecimiento.hasAgro){
        await dispatch('rubros/fetchListaRubro',null, {root:true})
      }
      if(state.establecimiento.hasGanaderia && state.currentGrupoExplotacion.categoria === 2){
        await dispatch('fichas/fetchFichaGanadera',null, {root:true})
        await dispatch('lotes/fetchListaInventarios',null, {root:true})
      }
    },

    async setEstablecimientoSimple({commit,dispatch}, establecimiento){
      commit('setEstablecimiento', establecimiento)
      if(establecimiento.grupoExplotacionList && establecimiento.grupoExplotacionList.length !== 0){
        commit('setGrupoExplotacion',establecimiento.grupoExplotacionList[0])
        commit('setGrupoExplotacionList', establecimiento.grupoExplotacionList)
      }
      await dispatch('temporada/fetchListaTemporadaAgricultor', null, {root:true})
      await dispatch('temporada/fetchTemporadaActual', null, {root:true})
    },

    async restoreEstablecimiento({commit, dispatch, rootState}) {
      let idAgricultorExplotacion = rootState.agricultor.agricultor.idAgricultor

      commit('restoreEstablecimiento')
      commit('restoreGrupoExplotacionList')
      await dispatch('fetchEstablecimientosList',idAgricultorExplotacion)
    },

    async fetchEstablecimientosList({commit,state,dispatch}, idAgricultorExplotacion){
      if ((state.establecimientosList && state.establecimientosList.length > 0) || idAgricultorExplotacion === 0) {
        return
      }

      let establecimientosList = await ConfiguracionRepository.listaEstablecimientos(idAgricultorExplotacion)
      commit('setEstablecimientoList', establecimientosList)
      
      let rememberedLast = state.establecimientosList.filter(establecimiento => establecimiento.idEstablecimiento === state.lastEstablecimiento)
      if (state.establecimientosList.length === 1 || (rememberedLast.length === 0 && state.establecimientosList.length !== 0)) {
        await dispatch('setEstablecimiento', state.establecimientosList[0])
      }else if(rememberedLast.length !== 0){
        await dispatch('setEstablecimiento', rememberedLast[0])
      }

    },

    async fetchEstablecimientosListSimple({commit,state},idAgricultorExplotacion){
      if ((state.establecimientosList && state.establecimientosList.length > 0) || idAgricultorExplotacion === 0) {
        return
      }

      let establecimientosList = await ConfiguracionRepository.listaEstablecimientos(idAgricultorExplotacion)
      commit('setEstablecimientoList', establecimientosList)
    },

    async clearEstablecimiento({commit,dispatch}){
      commit('clearEstablecimiento')
      // await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
    },

    clearEstablecimientoList({commit}){
      commit('clearEstablecimientoList')
    },

    async changeGrupoExplotacion({commit, dispatch, state}){
      let newGrupo = state.grupoExplotacionList.filter(grupo => grupo.idGrupoExplotacion !== state.currentGrupoExplotacion.idGrupoExplotacion)
      commit('setGrupoExplotacion', newGrupo[0])
      await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
      await dispatch('temporada/fetchListaTemporadaAgricultor', null, {root:true})
      await dispatch('temporada/fetchTemporadaActual', null, {root:true})
      await dispatch('fichas/fetchListaFichaAgricola', null, {root: true})
    },
  },
}  